<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <form id='addRuleForm'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-12 h-col-inputBox' style='padding-right: calc(50% + 50px);'>
          <div class='h-inputLit'>{{$t('Alarm.filteridentity')}}:</div>
          <ejs-textbox name='rulename' v-model='shieldRule.shieldrulename'></ejs-textbox>
        </div>
       
      </div>
      <div class='row h-row-inputBox'>
        <div class='col-sm-12 h-col-inputBox'>
          <div class='h-alarm-dialog-searchBorder'>
            <div class='col-sm-6 h-col-inputBox'>
              <div class='h-inputLit'>{{$t('Pm.ne_type_id')}}</div>
              <ejs-multiselect v-model='neTypeSelectData' :dataSource='neTypeData' :fields='neTypeFields' mode='CheckBox' :enableSelectionOrder='false' :showSelectAll='false' :change='neTypeChange'></ejs-multiselect>
            </div>
            <div class='col-sm-6 h-col-inputBox'>
              <div class='h-inputLit'>{{$t('Alarm.alarmLevel')}}</div>
              <div class='row' id='alarmLevelBox'>
                <div v-for='(alarm, index) in alarmLevelList' :key='index' class='col-sm-3 nopadding'>
                  <ejs-checkbox ref='alarmLevelCheck' name='alarmLevel' :label='alarm.label' :value='alarm.value' :checked='alarm.checked' :change='levelChangeFunc'></ejs-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='row h-reset-margin'>
        <div id='alarmTree'>
          <div class='h-padding-25'>
            <div class='height-280'>
              <AlarmTable ref='alarmTable'></AlarmTable>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { CheckBoxSelection } from '@syncfusion/ej2-vue-dropdowns';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import AlarmTable from './AlarmTable';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'addRule',
  components: {
    AlarmTable
  },
  data() {
    return {
      locale: localStorage.getItem('locale'),
      alarmLevelList: [
        { label: this.$t('Alarm.alarmLevel_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmLevel_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmLevel_2'), value: '2', checked: false },
        { label: this.$t('Alarm.alarmLevel_3'), value: '3', checked: false }
      ],
      alarmLevelArray: [],
      neTypeFields: { text: 'netype', value: 'netypeid' },
      neTypeData: [],
      neTypeSelectData: [],
      startdate: new Date(),
      enddate: new Date(),
      shieldRule: {
        shieldrulename: '',
        enddate: '',
        startdate: ''
      },
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          rulename: {
            required: [true, `${this.$t('Alarm.fieldIsRequired')}`],
            maxLength: [520, `${this.$t('Alarm.maxLength')}520`],
            regex: [/^[^'\\"<>%&\s]+$/, `${this.$t('Alarm.notInput')} ' " \\ < > &nbsp; % &`]
          },
        }
      }
    };
  },
  provide: {
    multiselect: [CheckBoxSelection]
  },
  watch: {
    startdate(val) {
      this.shieldRule.startdate = this.formatDataStr(val);
    },
    enddate(val) {
      this.shieldRule.enddate = this.formatDataStr(val);
    }
  },
  methods: {
    formatDataStr(val) {
      const dateValue = new Date(val);
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day}`;
    },
    getArray(id) {
      const checkedDom = document.querySelectorAll(`#${id} [aria-checked=true] input`);
      const array = [];
      for (let i = 0; i < checkedDom.length; i++) {
        array.push(checkedDom[i].value);
      }
      return array;
    },
    neTypeChange() {
      this.$refs.alarmTable.queryConditions.neTypeList = this.neTypeSelectData;
      this.$refs.alarmTable.getAlarmTableData();
    },
    levelChangeFunc() {
      this.alarmLevelArray = this.getArray('alarmLevelBox');
      this.$refs.alarmTable.queryConditions.alarmLevelList = this.alarmLevelArray;
      this.$refs.alarmTable.getAlarmTableData();
    },
    setRuleId(ruleInfo) {
      // 获取指定规则ID，查询详情
      this.clearData();
      this.shieldRule = {
        shieldrulename: ruleInfo.shieldrulename,
        enddate: '',
        startdate: '',
        shieldruleid: ruleInfo.shieldruleid
      };
      this.startdate = new Date(ruleInfo.startdate);
      if (ruleInfo.enddate === 4102415999000) {
        ruleInfo.enddate = 4102329600000; // 如果是2099-12-31 23:59:59 默认设置成 2099-12-31 00:00:00 时间 来解决表单验证问题.
      }
      this.enddate = new Date(ruleInfo.enddate);
      for (let i = 0; i < ruleInfo.alarmNeTypeList.length; i++) {
        this.$refs.alarmTable.alarmListCache[ruleInfo.alarmNeTypeList[i].alarmId+'-'+ruleInfo.alarmNeTypeList[i].neTypeId] = true;
      }
    },
    clearData() {
      this.bindValidate();
      this.shieldRule = {
        shieldrulename: '',
        enddate: '',
        startdate: ''
      };
      this.startdate = new Date();
      this.enddate = new Date();
      this.$refs.alarmTable.clearCache();
      const errorDom = document.querySelectorAll('label.e-error');
      for (let i = 0; i < errorDom.length; i++) {
        errorDom[i].innerHTML = '';
      }
    },
    getNeTypeData() {
      let arr = [];
        this.$axios.post('/lte/ems/topo/ne/findNeTypeMain').then((response) => {
        if (response && response.status === 200) {
          arr = response.data.resultVal;
          this.neTypeData = arr.filter((x, index,self)=>{
              // 资源类型只显示enodeb类型
              if (x.netypeid == 10004) {
                var arrids = []
                arr.forEach((item,i) => {
                  arrids.push(item.netypeid)
                })
                return arrids.indexOf(x.netypeid) === index
              }
            })
        }
      });

    },
    getRuleData() {
      if (!this.validate()) {
        return false;
      }
      const alarmArray = this.$refs.alarmTable.getCheckedData();
      if (alarmArray.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.alarmnull')});
        return false;
      }
      return {
        alarmStaticInfo: alarmArray,
        shieldRule: this.shieldRule
      };
    },
    bindValidate() {
      this.formObj = new FormValidator('#addRuleForm', this.validationOption);
    },
    validate() {
      console.log("this.formObj",this.formObj)
      console.log("this.formObj.validate()",this.formObj.validate())

      const formStatus = this.formObj.validate();
      console.log("formStatus",formStatus)

      return formStatus;
    }
  },
  beforeMount() {
    this.getNeTypeData();
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
